import { Component, OnInit, Input, HostBinding  } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { IAppState, IAppConfig } from '../../../app/store';
import {SiteURLUtils, SiteURL} from '../../common/site.url.utils';
import {Hotel} from '../../api/model/hotel/hotel.model';
import {MessageCategory} from '../../api/model/message/message-category.model';

@Component({
    selector: 'stay-mgmt-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {

  @Input() messages;
  @Input() enableText;
  @Input() hotel: Hotel;
  @Input() messageCategory: MessageCategory;
  @Input() hideHeader;
  @Input() hideBPG;

  private appConfig;
  stayManagementURL: string;

  constructor(private ngRedux: NgRedux<IAppState>) {
    this.appConfig = ngRedux.getState().appConfig as IAppConfig;
    this.stayManagementURL = SiteURLUtils.getLocalizedSiteUrl(this.appConfig, SiteURL.MANAGE_YOUR_STAY);
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/title/title.component.ts